import { X } from "lucide-react";

export function VersionsModal({ draft, onClose }) {
  if (!draft) return null;
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/40 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white border border-slate-200 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto fade-up" onClick={(e) => e.stopPropagation()} data-testid="versions-modal">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100 sticky top-0 bg-white rounded-t-2xl">
          <h3 className="font-display font-bold text-[#0f172a] text-sm">Version history — {draft.title}</h3>
          <button data-testid="versions-modal-close" onClick={onClose} className="text-slate-400 hover:text-[#0f172a]"><X size={18} /></button>
        </div>
        <div className="p-6 space-y-4">
          <div className="border border-indigo-200 bg-indigo-50/50 rounded-xl p-4">
            <p className="text-[10px] tracking-[0.15em] uppercase text-indigo-600 font-semibold mb-2">Current</p>
            <p className="text-xs text-slate-700 whitespace-pre-wrap">{draft.content?.slice(0, 400)}{draft.content?.length > 400 ? "…" : ""}</p>
          </div>
          {(draft.versions || []).slice().reverse().map((v) => (
            <div key={v.version} className="border border-slate-200 rounded-xl p-4">
              <p className="text-[10px] tracking-[0.15em] uppercase text-slate-400 font-semibold mb-2">
                v{v.version} · {v.note} · {new Date(v.created_at).toLocaleString()}
              </p>
              <p className="text-xs text-slate-500 whitespace-pre-wrap">{v.content?.slice(0, 400)}{v.content?.length > 400 ? "…" : ""}</p>
            </div>
          ))}
          {(draft.versions || []).length === 0 && <p className="text-xs text-slate-400">No previous versions.</p>}
        </div>
      </div>
    </div>
  );
}
